import cubejs from '@cubejs-client/core';
import jwt_decode from 'jwt-decode';
import { fetchReportToken } from 'services/api/report';
import { getCubeUrl } from 'utils';
import Store from 'state/store';

const BUFFER_SEC = 5;

let apiTokenPromise;

const cubejsApi = (type = null) =>
  cubejs(
    () => {
      // apiTokenPromise uses a singleton pattern to avoid multiple calls to token endpoint
      if (!apiTokenPromise) {
        apiTokenPromise = fetchReportToken().then((res) => {
          return res?.data?.token;
        });
      } else {
        // if token is already fetched, check if it is outdated or if theres a organization change
        // if so, fetch new token
        apiTokenPromise = apiTokenPromise.then((token) => {
          const now = parseInt(Date.now() / 1000);
          const state = Store.getState();

          try {
            const { exp, org_slug } = jwt_decode(token);
            const outdatedToken = now - BUFFER_SEC > exp;
            const organizationChange = org_slug !== state?.auth?.user?.organization?.id_slug;
            const renewToken = outdatedToken || organizationChange;
            if (renewToken) {
              return fetchReportToken().then((res) => res?.data?.token);
            } else {
              return token;
            }
          } catch (error) {
            console.error('Invalid token', token);
          }
        });
      }
      return apiTokenPromise;
    },
    {
      apiUrl: `${getCubeUrl(type ?? null)}/api/v1`,
    }
  );

export { cubejsApi };
